import React from 'react';
export function About() {
  return <section className="bg-rise-white text-rise-black py-12 md:py-20 px-6 overflow-hidden" data-id="element-30">
      <div className="max-w-rise-content mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-20 items-center" data-id="element-31">
        <div className="order-2 md:order-2" data-id="element-32">
          <div className="flex flex-col" data-id="element-33">
            <h2 className="font-playfair text-[32px] md:text-[42px] text-rise-black mb-6 text-center md:text-left" data-id="element-34">
              Sunt Teodora Trifu.
            </h2>
            <p className="font-dm-sans text-[19px] text-rise-gray mb-6 leading-relaxed text-left" data-id="element-35">
              Consilier pentru dezvoltare personală, cu 9 ani experiență în
              lucrul cu tineri și metode creative bazate pe arte combinate. De 5
              ani sunt implicată activ în sprijinirea dezvoltării emoționale a
              tinerilor prin ONG-ul pe care l-am construit.
            </p>
            <p className="font-dm-sans text-[19px] text-rise-gray mb-6 leading-relaxed text-left" data-id="element-36">
              Am văzut același tipar de zeci de ori: oameni inteligenți,
              sensibili și capabili care rămân blocați nu pentru că nu pot, ci
              pentru că nu au structură, claritate și un mediu care să îi
              susțină fără judecată.
            </p>
            <p className="font-dm-sans text-[19px] text-rise-gray mb-10 leading-relaxed text-left" data-id="element-37">
              De aceea am creat R.I.S.E.: un cadru simplu și clar care te ajută
              să treci de la confuzie și autosabotaj la identitate, stabilitate
              și progres real.
            </p>
            <div className="flex justify-center md:justify-start" data-id="element-38">
              <a href="https://comunitatearise.ro/despremine" target="_top" className="bg-rise-gold text-rise-black hover:bg-rise-gold-light px-8 py-4 rounded-xl font-dm-sans font-semibold text-[15px] transition-colors inline-flex items-center justify-center" data-id="element-39">
                Află mai multe despre mine
              </a>
            </div>
          </div>
        </div>

        <div className="order-1 md:order-1 relative max-w-md mx-auto w-full" data-id="element-40">
          {/* Large diamond / rhombus frame - top right */}
          <svg className="absolute -top-14 -right-14 w-48 h-48 text-rise-gold pointer-events-none" viewBox="0 0 150 150" fill="none" stroke="currentColor" strokeWidth="0.7" data-id="element-41">
            <rect x="75" y="5" width="95" height="95" rx="4" transform="rotate(45 75 52)" data-id="element-42" />
            <rect x="75" y="15" width="72" height="72" rx="3" transform="rotate(45 75 52)" strokeDasharray="3 5" data-id="element-43" />
          </svg>

          {/* Starburst / radial lines - top left */}
          <svg className="absolute -top-10 -left-10 w-32 h-32 text-rise-gold/50 pointer-events-none" viewBox="0 0 100 100" fill="none" stroke="currentColor" strokeWidth="0.5" data-id="element-44">
            <line x1="50" y1="50" x2="50" y2="5" data-id="element-45" />
            <line x1="50" y1="50" x2="82" y2="12" data-id="element-46" />
            <line x1="50" y1="50" x2="95" y2="50" data-id="element-47" />
            <line x1="50" y1="50" x2="82" y2="88" data-id="element-48" />
            <line x1="50" y1="50" x2="50" y2="95" data-id="element-49" />
            <line x1="50" y1="50" x2="18" y2="88" data-id="element-50" />
            <line x1="50" y1="50" x2="5" y2="50" data-id="element-51" />
            <line x1="50" y1="50" x2="18" y2="12" data-id="element-52" />
            <circle cx="50" cy="50" r="8" strokeWidth="0.6" data-id="element-53" />
            <circle cx="50" cy="50" r="2.5" fill="currentColor" data-id="element-54" />
          </svg>

          {/* Horizontal thin lines - bottom left */}
          <svg className="absolute -bottom-8 -left-16 w-44 h-20 text-rise-gold/30 pointer-events-none" viewBox="0 0 160 60" fill="none" stroke="currentColor" strokeWidth="0.5" data-id="element-55">
            <line x1="0" y1="10" x2="160" y2="10" data-id="element-56" />
            <line x1="20" y1="22" x2="140" y2="22" data-id="element-57" />
            <line x1="40" y1="34" x2="120" y2="34" data-id="element-58" />
            <line x1="55" y1="46" x2="105" y2="46" data-id="element-59" />
          </svg>

          {/* Organic curve - bottom right */}
          <svg className="absolute -bottom-16 -right-12 w-52 h-52 text-rise-gold/40 pointer-events-none" viewBox="0 0 200 200" fill="none" stroke="currentColor" strokeWidth="0.6" data-id="element-60">
            <path d="M20 180 Q 60 100 120 120 T 180 40" strokeDasharray="4 4" data-id="element-61" />
            <path d="M30 190 Q 70 120 130 135 T 190 50" strokeDasharray="1 6" data-id="element-62" />
          </svg>

          {/* Small cross accents */}
          <svg className="absolute top-8 -right-7 w-5 h-5 text-rise-gold pointer-events-none" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5" data-id="element-63">
            <line x1="10" y1="2" x2="10" y2="18" data-id="element-64" />
            <line x1="2" y1="10" x2="18" y2="10" data-id="element-65" />
          </svg>
          <svg className="absolute bottom-12 -left-6 w-4 h-4 text-rise-gold/70 pointer-events-none" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5" data-id="element-66">
            <line x1="10" y1="2" x2="10" y2="18" data-id="element-67" />
            <line x1="2" y1="10" x2="18" y2="10" data-id="element-68" />
          </svg>

          {/* Scattered gold dots */}
          <div className="absolute -top-4 left-16 w-3 h-3 rounded-full bg-rise-gold pointer-events-none" data-id="element-69"></div>
          <div className="absolute top-20 -right-5 w-2 h-2 rounded-full bg-rise-gold/50 pointer-events-none" data-id="element-70"></div>
          <div className="absolute -bottom-3 right-24 w-2.5 h-2.5 rounded-full bg-rise-gold pointer-events-none" data-id="element-71"></div>
          <div className="absolute bottom-32 -left-3 w-2 h-2 rounded-full bg-rise-gold/60 pointer-events-none" data-id="element-72"></div>
          <div className="absolute top-1/2 -right-8 w-1.5 h-1.5 rounded-full bg-rise-gold pointer-events-none" data-id="element-73"></div>

          {/* Double offset borders */}
          <div className="absolute inset-0 border border-rise-gold/60 rounded-xl translate-x-5 translate-y-5 pointer-events-none" data-id="element-74"></div>
          <div className="absolute inset-0 border border-rise-gold/25 rounded-xl -translate-x-3 -translate-y-3 pointer-events-none" data-id="element-75"></div>

          <img src="https://cdn.magicpatterns.com/uploads/iUcBmPMC4srAe2sezJvkST/Teodora_3.jpg" alt="Teodora Trifu" className="w-full h-auto md:h-[600px] object-cover object-top rounded-xl shadow-xl z-10 relative" data-id="element-76" />
        </div>
      </div>
    </section>;
}